'use strict';

const libPictView = require('pict-view');

/**
 * Customers — the #/Customers list (front door to the per-customer Customer workspace). A thin shell (like
 * ManageCustomers.js / SuperUserGrant.js): all data + logic + hand-built HTML live in the CustomersList provider,
 * which assigns into the #CL-Body mount. Rows open #/Customer/Workspace/:ID; the per-row "Manage Configuration"
 * button (impersonation-gated) signs in as the customer's configuration admin. See [[config-app-customer-dashboard]].
 */
class Customers extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.CustomersList; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = Customers;
module.exports.default_configuration =
{
	ViewIdentifier: 'Customers',
	DefaultRenderable: 'CustomersWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.cl-wrap { padding: 1.25rem 1.5rem 2rem; }
		.cl-head { margin: 0 0 1rem; }
		.cl-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.cl-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; max-width:60rem; }
		.cl-note { padding:0.9rem; font-size:0.9rem; color:var(--theme-color-text-muted,#8894a4); }
		.cl-error { padding:0.9rem; font-size:0.88rem; color:var(--theme-color-status-danger,#c0392b); }
		/* Tabs: Customers roster | New Customers requests */
		.cl-tabs { display:flex; gap:0.25rem; margin:0 0 1rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f5); }
		.cl-tab { display:inline-flex; align-items:center; gap:0.45rem; padding:0.55rem 0.95rem; font-size:0.92rem; font-weight:600; text-decoration:none; color:var(--theme-color-text-muted,#6b7686); border-bottom:2px solid transparent; margin-bottom:-1px; }
		.cl-tab:hover { color:var(--theme-color-text-primary,#1f2733); }
		.cl-tab.is-active { color:var(--theme-color-primary,#2f6fed); border-bottom-color:var(--theme-color-primary,#2f6fed); }
		.cl-tab .fas { font-size:0.85em; }
		/* New Customers bar: summary + "New Customer" action */
		.cl-newbar { display:flex; align-items:center; justify-content:space-between; gap:1rem; margin:0 0 0.8rem; max-width:60rem; flex-wrap:wrap; }
		.cl-newsummary { font-size:0.88rem; color:var(--theme-color-text-muted,#6b7686); margin:0; }
		.cl-newsummary strong { color:var(--theme-color-text-primary,#1f2733); }
		.cl-newbtn { display:inline-flex; align-items:center; gap:0.4rem; font-size:0.86rem; font-weight:600; cursor:pointer; padding:0.45rem 0.85rem; border-radius:8px; border:1px solid var(--theme-color-primary,#2f6fed); background:var(--theme-color-primary,#2f6fed); color:#fff; }
		.cl-newbtn:hover { filter:brightness(1.06); }
		.cl-col-status { flex:0 0 11rem; display:inline-flex; align-items:center; }
		/* New Customers filter row: name filter + provisioned segmented control */
		.cl-filterrow { display:flex; align-items:center; gap:0.75rem; margin:0 0 0.8rem; max-width:60rem; flex-wrap:wrap; }
		.cl-filter-inrow { flex:1 1 16rem; margin:0; max-width:none; }
		.cl-segctl { display:inline-flex; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:8px; overflow:hidden; }
		.cl-seg { display:inline-flex; align-items:center; gap:0.4rem; font-size:0.82rem; font-weight:600; cursor:pointer; padding:0.5rem 0.8rem; border:0; border-left:1px solid var(--theme-color-border-light,#eef1f5); background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-muted,#6b7686); white-space:nowrap; }
		.cl-seg:first-child { border-left:0; }
		.cl-seg:hover { background:var(--theme-color-background-secondary,#f4f6f9); color:var(--theme-color-text-primary,#1f2733); }
		.cl-seg.is-active { background:var(--theme-color-primary,#2f6fed); color:#fff; }
		.cl-seg-count { font-size:0.72rem; font-weight:700; padding:0.02rem 0.4rem; border-radius:999px; background:var(--theme-color-background-secondary,#eef1f5); color:var(--theme-color-text-muted,#6b7686); }
		.cl-seg.is-active .cl-seg-count { background:rgba(255,255,255,0.25); color:#fff; }
		.cl-row-static { cursor:default; }
		.cl-row-static:hover { background:transparent; }
		/* New Customers row approval actions */
		.cl-col-newactions { flex:0 0 auto; display:inline-flex; align-items:center; gap:0.4rem; margin-left:auto; }
		.cl-actbtn { display:inline-flex; align-items:center; gap:0.35rem; font-size:0.8rem; font-weight:600; cursor:pointer; padding:0.3rem 0.65rem; border-radius:7px; white-space:nowrap; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-primary,#fff); color:var(--theme-color-text-primary,#1f2733); }
		.cl-actbtn:hover { border-color:var(--theme-color-primary,#2f6fed); color:var(--theme-color-primary,#2f6fed); }
		.cl-actbtn-approve { border-color:#b7dfc4; color:#1b6e3a; }
		.cl-actbtn-approve:hover { background:#1b6e3a; border-color:#1b6e3a; color:#fff; }
		.cl-actbtn-reject { border-color:#e3b7b4; color:#b3382f; }
		.cl-actbtn-reject:hover { background:#b3382f; border-color:#b3382f; color:#fff; }
		.cl-actbusy { color:var(--theme-color-text-muted,#8a94a3); font-size:0.85rem; padding:0 0.4rem; }
		.cl-badge { display:inline-block; font-size:0.72rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; padding:0.12rem 0.5rem; border-radius:999px; line-height:1.5; }
		.cl-badge-prov { color:#1b6e3a; background:#e4f5ea; }
		.cl-badge-pend { color:#8a5a00; background:#fdf1dc; }
		.cl-badge-draft { color:#5a6676; background:#eef1f5; }
		.cl-badge-rej { color:#b3382f; background:#fbeaea; }
		.cl-filter { width:100%; max-width:32rem; box-sizing:border-box; font-size:0.95rem; padding:0.55rem 0.75rem; margin:0 0 0.8rem;
			border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:8px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.cl-filter:focus { outline:none; border-color:var(--theme-color-primary,#2f6fed); box-shadow:0 0 0 2px rgba(47,111,237,0.15); }
		/* No max-height / overflow-y here: the app shell already scrolls the page (html overflow-y:scroll), so the
		   list flex-grows naturally and the browser's own scroll handles long lists — no nested scroll box. */
		.cl-list { border:1px solid var(--theme-color-border-light,#eef1f5); border-radius:10px; overflow:hidden; background:var(--theme-color-background-primary,#fff); max-width:60rem; }
		.cl-head-row { display:flex; align-items:center; gap:0.9rem; padding:0.45rem 0.9rem; font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#8a94a3); background:var(--theme-color-background-secondary,#f4f6f9); border-bottom:1px solid var(--theme-color-border-light,#eef1f5); }
		.cl-row { display:flex; align-items:center; gap:0.9rem; padding:0.6rem 0.9rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f5); font-size:0.92rem; color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.cl-row:last-child { border-bottom:none; }
		.cl-row:hover { background:var(--theme-color-background-secondary,#f4f6f9); }
		.cl-row:focus { outline:2px solid var(--theme-color-primary,#2f6fed); outline-offset:-2px; }
		.cl-col-name { flex:1 1 auto; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; font-weight:600; }
		.cl-col-code { flex:0 0 8rem; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.82rem; color:var(--theme-color-text-muted,#8a94a3); }
		.cl-col-action { flex:0 0 auto; display:inline-flex; align-items:center; gap:0.6rem; }
		.cl-disabled { color:var(--theme-color-text-muted,#aab2bf); font-style:italic; font-size:0.82rem; font-weight:400; }
		.cl-open-caret { font-size:0.8rem; color:var(--theme-color-text-muted,#aab2bf); }
		.cl-btn { display:inline-flex; align-items:center; gap:0.4rem; font-size:0.8rem; font-weight:600; cursor:pointer; padding:0.3rem 0.65rem; border-radius:7px; white-space:nowrap; }
		.cl-btn-ghost { border:1px solid var(--theme-color-brand-primary,#156dd1); background:transparent; color:var(--theme-color-brand-primary,#156dd1); }
		.cl-btn-ghost:hover, .cl-btn-ghost.is-open { background:var(--theme-color-brand-primary,#156dd1); color:#fff; }
		.cl-btn-caret { font-size:0.7rem; opacity:0.85; }
		/* Each customer is an item (row + optional expanded accounts panel); the item carries the row divider. */
		.cl-item { border-bottom:1px solid var(--theme-color-border-light,#eef1f5); }
		.cl-item:last-child { border-bottom:none; }
		.cl-item .cl-row { border-bottom:none; }
		.cl-item.is-expanded { background:var(--theme-color-background-secondary,#f4f6f9); }
		.cl-item.is-expanded > .cl-row:hover { background:transparent; }
		.cl-accounts { display:flex; flex-direction:column; gap:0.3rem; padding:0 0.9rem 0.75rem 1.5rem; }
		.cl-accounts-head { font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:var(--theme-color-text-muted,#8a94a3); margin:0.1rem 0 0.25rem; }
		.cl-accounts-note { font-size:0.86rem; padding:0.35rem 0; }
		.cl-accounts-note a { color:var(--theme-color-brand-primary,#156dd1); font-weight:600; }
		.cl-account { display:flex; align-items:center; gap:0.6rem; width:100%; max-width:34rem; text-align:left; padding:0.4rem 0.55rem; border:1px solid var(--theme-color-border-light,#e8ebf0); border-radius:8px; background:var(--theme-color-background-primary,#fff); cursor:pointer; }
		.cl-account:hover { border-color:var(--theme-color-brand-primary,#156dd1); background:var(--theme-color-brand-primary-subtle,#eaf2fc); }
		.cl-account-avatar { flex:0 0 auto; width:1.75rem; height:1.75rem; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; background:var(--theme-color-background-secondary,#eef1f6); color:var(--theme-color-text-muted,#8a94a3); font-size:0.8rem; }
		.cl-account-id { flex:1 1 auto; min-width:0; display:flex; flex-direction:column; }
		.cl-account-name { font-size:0.88rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.cl-account-login { font-size:0.74rem; color:var(--theme-color-text-muted,#8a94a3); font-family:ui-monospace,SFMono-Regular,Menlo,monospace; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.cl-account-go { flex:0 0 auto; font-size:0.78rem; font-weight:600; color:var(--theme-color-brand-primary,#156dd1); display:inline-flex; align-items:center; gap:0.3rem; }
	`,
	Templates:
	[
		{
			Hash: 'Customers-Wrap',
			Template: /*html*/`
				<div class="cl-wrap">
					<div class="cl-head">
						<h1 class="cl-title">Customers</h1>
						<p class="cl-subtitle">Open a customer to manage its overview, users, modules, and team. <strong>Manage Configuration</strong> signs you in as the customer&#8217;s configuration admin to edit their configuration directly.</p>
					</div>
					<div id="CL-Body"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'CustomersWrap',
			TemplateHash: 'Customers-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
